// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"b2ffb5fb","231":"c45324ca","338":"af3c71e1","396":"1b3529c2","447":"c6e88224","599":"867fbbeb","609":"2c9d87b7","777":"25bbebe0","907":"a4437b32","962":"41c43e68"}[chunkId] + ".chunk.js";
};